import classes from "./Introduction.module.css";
import React, { useEffect, useContext, useState } from "react";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";
import RemoteConfig from "../../services/RemoteConfig";
import AuthContext from "../../store/auth-context";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import useCheckIsMobile from "../../hook/useCheckIsMobile";
import MainCarousel from "../Carousel/Carousel";
import InstagramFeed from "../InstagramFeed/InstagramFeed";

const Introduction = (props) => {
  const { introductionRef } = props || {};
  const isMobile = useCheckIsMobile();

  return (
    <div ref={introductionRef} className={classes.container}>
      <div className={classes.introduction}>
        <div className={classes.textContainer}>
          <h1>{`Feel Your Best, Every Visit\n`}</h1>
          <h4>
            {`Step into a space designed for relaxation and beauty. From detailed manicures and soothing pedicures to elegant nail enhancements, we use high-quality products and expert techniques to keep your nails strong, healthy, and beautiful—so you leave looking polished and feeling refreshed.`}
          </h4>
          <BookNowBtn />
        </div>

        <div
          style={{
            borderBottomLeftRadius: "100%",
            borderBottomRightRadius: "100%",
          }}
        >
          <img
            className={classes.imageStyle}
            alt={"Introduction"}
            src={images.nail_shop3}
          />
        </div>
      </div>
      <InstagramFeed />

      <div className={classes.contactStaffContainer}>
        <div className={classes.wrapperStyling}>
          <h1>Talk to our staff</h1>
          <h4 style={{marginTop:'2vh',marginBottom: '4vh'}}>
            Our friendly and knowledgeable team at T Nail Spa is here to assist
            you with any questions or recommendations. Whether you’re looking
            for advice on the perfect nail treatment or need help choosing a
            color, our staff is always ready to provide personalized care and
            ensure your experience is exceptional.
          </h4>
          <BookNowBtn style={classes.bookNowBtnStyle}/>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
